// Minnesotaänger Mini App — scroll-down button (v1 trim).
// Trimmed from telegram-tt: removed the unread badge and the read-all
// context menu (v1 has no read receipts); the lang-key ariaLabel became a
// plain string, dropping the useLang/useOldLang dependency.

import type { FC } from '../../lib/teact/teact';
import { memo } from '../../lib/teact/teact';

import type { IconName } from '../../types/icons';

import buildClassName from '../../util/buildClassName';

import Button from '../ui/Button';

import styles from './ScrollDownButton.module.scss';

type OwnProps = {
  icon: IconName;
  ariaLabel: string;
  onClick: VoidFunction;
  className?: string;
};

const ScrollDownButton: FC<OwnProps> = ({ icon, ariaLabel, onClick, className }) => {
  return (
    <div className={buildClassName(styles.root, className)}>
      <Button
        color="secondary"
        round
        className={styles.button}
        onClick={onClick}
        ariaLabel={ariaLabel}
        iconName={icon}
        iconClassName={styles.icon}
      />
    </div>
  );
};

export default memo(ScrollDownButton);
